import React from "react";
import { withTranslation } from "react-i18next";
import { PropTypes } from "prop-types";
import { CopyToClipboard } from "react-copy-to-clipboard";

import FileCopyIcon from "@material-ui/icons/FileCopy";
import ZapierLine from "components/platform/configuration/zapier/ZapierLine";
import InfoTooltip from "components/utils/InfoTooltip";

import "css/common/checkbox.scss";

function ZapierSection({ triggers, t, onChange, apiKey, onSuccess, enabled }) {
  const changeTrigger = (trigger, idx) => {
    const newTriggers = triggers.map((item, itIdx) =>
      itIdx === idx ? { ...trigger } : item,
    );
    onChange(newTriggers);
  };
  return (
    <div className="editor-form-section">
      <div className="editor-form-section-title">
        {t("zapierConfiguration")}
      </div>
      {enabled && apiKey && (
        <div className="editor-form-row zapier-key">
          <div className="editor-form-input">
            <div className="editor-form-input-label">
              <label>{t("zapierKey")}</label>
              <InfoTooltip position="center">{t("zapierTooltip")}</InfoTooltip>
            </div>
            <div className="input">
              <input disabled type="text" value={apiKey} maxLength="128" />
              <span>
                <CopyToClipboard
                  text={apiKey}
                  onCopy={() => onSuccess(t("success_copy"))}
                >
                  <FileCopyIcon />
                </CopyToClipboard>
              </span>
            </div>
          </div>
        </div>
      )}
      <div className="editor-form-row zapier-grid">
        <div className="zapier-cell" />
        <div className="zapier-cell center">{t("zapierEmail")}</div>
        <div className="zapier-cell center">{enabled && t("zapierTitle")}</div>
        {triggers.map(({ email, event_name, zapier }, idx) => (
          <ZapierLine
            key={event_name}
            email={email}
            enabled={enabled}
            zapier={zapier}
            event_name={event_name}
            onChange={(trigger) => changeTrigger(trigger, idx)}
          />
        ))}
      </div>
    </div>
  );
}

ZapierSection.propTypes = {
  enabled: PropTypes.bool,
  apiKey: PropTypes.string,
  triggers: PropTypes.arrayOf(
    PropTypes.shape({
      zapier: PropTypes.number,
      email: PropTypes.bool,
      event_name: PropTypes.string,
    }),
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation("editor-platform")(ZapierSection);
